export type StatisticsDateError = 'invalidDate' | 'requiredDates' | 'dateOrder' | 'maxRange';

export interface StatisticsDateRange {
  dateFrom: string;
  dateTo: string;
}

/** Maximum span between `dateFrom` and `dateTo` (both inclusive): 2024-01-01 → 2024-12-31 at most. */
export const STATISTICS_MAX_RANGE_YEARS = 1;

export function isValidISODate(val: string): boolean {
  if (!(/^\d{4}-\d{2}-\d{2}$/).test(val)) return false;
  const d = new Date(val + 'T12:00:00Z');
  return !isNaN(d.getTime()) && d.toISOString().slice(0, 10) === val;
}

function addYears(isoDate: string, years: number): string {
  const [y, m, d] = isoDate.split('-').map(Number);
  // Day overflow (29 Feb + 1 year) rolls into 1 Mar, so 2024-02-29 → 2025-02-28 is still accepted.
  return new Date(Date.UTC(y + years, m - 1, d)).toISOString().slice(0, 10);
}

/**
 * Validates the statistics date filter. ISO dates (`YYYY-MM-DD`) compare correctly as strings.
 * `badInput` comes from the native date input, which reports an empty value for a partial date.
 */
export function validateStatisticsRange(
  dateFrom: string | null | undefined,
  dateTo: string | null | undefined,
  badInput = false,
): StatisticsDateError | null {
  if (badInput) return 'invalidDate';
  if (!dateFrom || !dateTo) return 'requiredDates';
  if (!isValidISODate(dateFrom) || !isValidISODate(dateTo)) return 'invalidDate';
  if (dateFrom > dateTo) return 'dateOrder';
  if (dateTo >= addYears(dateFrom, STATISTICS_MAX_RANGE_YEARS)) return 'maxRange';
  return null;
}
